export default __webpack_public_path__ + "static/media/hemp-protein.c7a6e101.jpeg";